export const requirements = {
  Mapped_Protocol_Questions: "Questões de Protocolo Mapeadas",
  Requirement_content: "Conteúdo do requisito",
  Requirement_Ref: "Ref. do Requisito",
  Requirements: "Requisitos",
  Section_Ref: "Ref. da Seção",
  Section_Title: "Título da Seção",
  Standard: "Padrão",
  Standard_Requirements: "Requisitos do Padrão",
  Standards: "Padrões",
  Sub_Section_Ref: "Ref. da Subseção",
  Sub_Section_Title: "Título da Subseção",
} as const;
